import gql from 'graphql-tag'
import { PRODUCT_FRAGMENT } from './fragments.graphql'

export const GET_PRODUCTS_BY_IDS = gql`
  ${PRODUCT_FRAGMENT}

  query GetProductsByIds($productErpIdentifiers: [String!]!) {
    products(productErpIdentifiers: $productErpIdentifiers) {
      ...Product
      category {
        englishPathSlug
        name
      }
    }
  }
`
